import { csrfToken } from "utils/csrf-token"
import { SERVER_FORM_ERROR } from "../constants"

/* eslint-disable no-underscore-dangle */
class PhotosService {
  /**
   * Creates an instance of PhotosService.
   * @param {string} token
   * @param {string} location
   * @memberof PhotosService
   */
  constructor(token, location) {
    this._token = token
    this._location = location
  }

  /**
   * @param {string} photoId
   * @param {object} options
   * @param {number} options.forward
   * @param {number} options.backward
   * @returns {Promise<{ photos: Object<number, ?Object> }>}
   * @memberof PhotosService
   */
  get(photoId, { forward = 0, backward = 0 }) {
    const url = `/photos/${photoId}/navigation?location=${this._location}&num_forward=${forward}&num_backward=${backward}`

    return fetch(url, {
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": csrfToken() || this._token,
      },
    }).then((response) => {
      if (response.ok) {
        return response.json()
      }

      throw new Error(`${response.status}: ${response.statusText}`)
    })
  }

  /**
   * @param {Number} photoId
   * @param {Number} rating
   * @returns {Promise<{ success: Boolean, error: string? }>}
   * @memberof PhotosService
   */
  async vote(photoId, rating) {
    const url = `/photos/${photoId}/photo_votes`

    const response = await fetch(url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken() || this._token,
      },
      body: JSON.stringify({
        photo_vote: {
          rating,
        },
      }),
    })

    if (response.ok || response.status === 422) {
      try {
        const responseAsJson = await response.json()

        if (responseAsJson.success === true) {
          return {
            success: true,
            error: null,
          }
        }

        if (Object.hasOwnProperty.call(responseAsJson, SERVER_FORM_ERROR)) {
          return {
            success: false,
            error: responseAsJson[SERVER_FORM_ERROR],
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)

        const responseAsText = await response.text()
        return {
          success: false,
          error: `Failed parsing JSON: ${responseAsText}`,
        }
      }
    }

    // eslint-disable-next-line no-console
    console.error(`${response.status}: ${response.statusText}`)

    return {
      success: false,
      error: `${response.status}: ${response.statusText}`,
    }
  }
}

export default PhotosService
